/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".place-map-section{height:100%}.place-map-section agm-map{height:60%!important}.place-map-section [group]{height:calc(40% - 8px)}.place-map-section [group] ig-button{height:28%}.place-map-section [group] ig-button button{line-height:1}.place-map-section [group] ig-add-to-trip-menu .btn-div{margin-top:8px;padding:0!important;font-size:14px;height:28%}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/place.map.section.component/place.map.section.component.scss.ngstyle.js.pre-build-optimizer.js